import { Checkbox } from "@mantine/core";
import CheckboxSurvey from "../../../components/form/Checkbox";
import { useTranslation } from "react-i18next";

type Props = {
  form: any;
};

const OPTIONS_VALUES = [
  "act_001",
  "act_002",
  "act_003",
  "act_004",
  "act_005",
  "act_006",
  "act_007",
  "act_008",
];

const Component = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <CheckboxSurvey
      label={t("witnessActionsQuestions.label")}
      {...form.getInputProps("ACT_001_008")}
    >
      {(
        t("witnessActionsQuestions.options", {
          returnObjects: true,
        }) as string[]
      ).map((option, index) => (
        <Checkbox
          key={OPTIONS_VALUES[index]}
          label={option}
          value={OPTIONS_VALUES[index]}
        />
      ))}
    </CheckboxSurvey>
  );
};

export default Component;
